var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBlackLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9139 11.9952L8.28708 6.56885C8.09569 6.38428 8.00319 6.16895 8.00957 5.92285C8.01595 5.67676 8.11483 5.46143 8.30622 5.27686C8.49761 5.09228 8.72089 5 8.97608 5C9.23126 5 9.45455 5.09228 9.64593 5.27686L15.5407 10.9432C15.6938 11.0908 15.8086 11.257 15.8852 11.4415C15.9617 11.6261 16 11.8107 16 11.9952C16 12.1798 15.9617 12.3644 15.8852 12.5489C15.8086 12.7335 15.6938 12.8996 15.5407 13.0473L9.64593 18.7321C9.45455 18.9166 9.22807 19.0059 8.96651 18.9997C8.70494 18.9935 8.47847 18.8982 8.28708 18.7136C8.09569 18.529 8 18.3137 8 18.0676C8 17.8215 8.09569 17.6062 8.28708 17.4216L13.9139 11.9952Z",
    fill: "#1C2227"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlackLarge);
export default __webpack_public_path__ + "static/media/arrow_right_black_large.643458e404d4478c0695d644ed9954a8.svg";
export { ForwardRef as ReactComponent };